import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { assets } from '../../../assets/assets';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMultipleQuotationData } from '../../../Store/PHPSlice/Sale/MultipleQuot';
import { selectMultipleQuotData } from '../../Selectors/Master/MasterSelectors';
import { useParams } from 'react-router-dom';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';

const RetailerView = () => {
    const { Id } = useParams();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    const dispatch = useDispatch();
    const mqtdata = useSelector(selectMultipleQuotData);

    useEffect(() => {
        dispatch(fetchMultipleQuotationData(Id));
    }, [Id]);

    // console.log(mqtdata);
    const formdata = mqtdata?.data;
    const tableContainerStyle = {
        marginLeft: isDesktop ? '0%' : '0%',
        width: isDesktop ? '98%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const terms = [
        { id: '1', label: 'The garment samples will be produce against the counter samples from buyer/client and accordingly the rates will be given.' },
        { id: '2', label: 'In Case of any changes & Addition in pattern from buyer, regarding fabric quality or pattern or Accessories or Size chart the given price list may revised.' },
        { id: '3', label: 'Fabric Availability- Will be decided as per the quality &quantity. Available fabric can be held for 5 working days, buyer has to confirm order to ensure the fabric availability.' },
        { id: '4', label: 'At the time of bulk order buyer must inform regarding the refill order confirmation against the bulk order, so that the fabrics can be reserved against the refill order and carry the stock for timely delivery of garment quantity.' },
        { id: '5', label: 'Garment Delivery schedule will be given once the order is confirmed & on the fulfillment of the payment term applicable.' },
        { id: '6', label: 'The Minimum order qty of single style will be 200 pieces (per Size minimum qty will be 20 pieces).' },
        { id: '7', label: 'In case the order quantity is below 200 pieces additional rate of 15% will be chargeable.' },
        { id: '8', label: 'The actual delivery quantity of all the order will be +/- 5% from the order quantity. No return of this + 5% is accepted. If required will be treated as new order & new d delivery period / Subject to -5% Qty is above 100Pcs.' },
    ];

    const payment = [
        { id: '1', label: 'Any order below 2 Lac will be on 100% advance payment.' },
        { id: '2', label: 'Between 2 Lac and 10 lakhs will be 50% Advance and balance PDC of 30 days.' },
        { id: '3', label: 'Above 10 Lac will be 25% Advance and balance PDC of 45 days.' },
        { id: '4', label: 'Orders which are of higher value than 20 lakhs will be taken on case-to-case basis.' },
        { id: '5', label: 'In case for maintaining fabric stock, against specific order, Separate SO will be generated against extra fabric stock and50% of that SO amount will be taken as deposit.' },
        { id: '6', label: 'In case of raise in Fabric rates, new rates will be applicable on spillover orders of all old orders.' },
    ];

    const returnReplacement = [
        { id: '1', label: 'Goods once sold cannot be returned unless verified &genuine complaint regardinggarment.' },
        { id: '2', label: 'Material must be returned within 30 Days from the date of receipt. After that no complain will be entertained.' },
        { id: '3', label: 'Lorry Receipt of all Return Goods Should be booked at Solapur factory after approval of concern marketing person, if the goods are booked by the buyer without approval the goods will not beaccepted.' },
    ];
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        {/* <img src={assets?.firmImg} alt="error" /> */}

                        {/* {mqtdata?.data?.firmId !== '' && <FirmHeaderImg firmId={mqtdata?.data?.firmId} />} */}

                        <FirmHeaderImg quotNm='mafatlal_header' />

                        <h3 className='centered-heading'>Quotation (Retailer)</h3>
                        <div className="dashed-line" style={{ margin: '1% 0%' }}></div>

                        <table style={{ margin: '1% 0%', fontSize: '15px' }}>

                            <tbody>

                                <tr>

                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{formdata?.dt}</td>
                                    <td style={{ width: '200px' }}>Multiple Quot. Memo</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formdata?.qtMemo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Firm</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formdata?.firmNm}</td>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formdata?.partyNm}</td>

                                </tr>

                            </tbody>

                        </table>

                        <h3 className='centered-heading'>Price List</h3>

                        {formdata?.data2?.length > 0 &&

                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                {
                                    formdata?.data2?.map((quot, index) => (
                                        <Table key={index}>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '5%' }} align='center'>Quotation No</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '30%' }} align='center'>Size</TableCell>
                                                    {quot?.Info ? quot?.Info?.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item?.size}</TableCell>
                                                    )) : ''}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* <TableRow>
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{quot?.quotNo}</TableCell>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{quot?.itemNm} -
                                                        <br /> {quot?.mclothNm} {quot?.m1cloth !== '0' && <br />}{quot?.m1cloth !== '0' && quot?.m1clothNm} {quot?.m2cloth !== '0' && <br />}
                                                        {quot?.m2cloth !== '0' && quot?.m2clothNm} {quot?.m3cloth !== '0' && <br />}{quot?.m3cloth !== '0' && quot?.m3clothNm}</TableCell>
                                                    {quot?.Info ? quot?.Info?.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item?.retailer_rate}</TableCell>
                                                    )) : ''}
                                                </TableRow> */}
                                                <TableRow>
    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
        {quot?.quotNo}
    </TableCell>

    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
        {quot?.qtnm} -
        <br />
        <b>Main Cloth - </b> {quot?.mmodel}

        {quot?.m1cloth !== '0' && <br />}
        {quot?.m1cloth !== '0' && <><b>M1 - </b>{quot?.m1model}</>}

        {quot?.m2cloth !== '0' && <br />}
        {quot?.m2cloth !== '0' && <><b>M2 - </b>{quot?.m2model}</>}

        {quot?.m3cloth !== '0' && <br />}
        {quot?.m3cloth !== '0' && <><b>M3 - </b>{quot?.m3model}</>}
    </TableCell>

    {quot?.Info ? quot?.Info?.map((item, index) => (
        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>
            {item?.scr_rate}
        </TableCell>
    )) : ''}
</TableRow>
                                            </TableBody>
                                        </Table>
                                    ))
                                }
                            </TableContainer>
                        }

                        <div style={{ marginTop: '3%', marginLeft: '5%' }}>
                            <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Terms & Conditions</h4>
                            <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                {terms?.map((item, index) => (
                                    <li key={item.id}>{item.label}</li>
                                ))}
                            </ol>
                        </div>

                        <div style={{ marginTop: '3%', marginLeft: '5%' }}>
                            <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Payment Terms</h4>
                            <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                {payment?.map((item, index) => (
                                    <li key={item.id}>{item.label}</li>
                                ))}
                            </ol>
                        </div>

                        <div style={{ marginTop: '3%', marginLeft: '5%' }}>
                            <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Return & Replacement</h4>
                            <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                {returnReplacement?.map((item, index) => (
                                    <li key={item.id}>{item.label}</li>
                                ))}
                            </ol>
                        </div>


                        <div style={{ float: 'right', marginRight: '10%', textAlign: 'center' }}>
                            <h4 style={{ marginBottom: '3rem' }}>Authorized By</h4>
                            <h6>MAFATLAL INDUSTRIES LIMITED</h6>
                        </div>
                    </div>
                    <div style={{ margin: '2% 5%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
}

export default RetailerView;
